<div class="header-row">
    <form [formGroup]="searchForm" (ngSubmit)="filterItems()">
        <input
            hamInput
            icon="/assets/hamIcons/search-outline.svg"
            formControlName="searchTerm"
            placeholder="{{ 'aumico_text_snippets_table_search_placeholder' | i18next }}"
            (cancel)="resetFilter()"
        />
    </form>
    <ham-button icon="assets/hamIcons/plus-outline.svg" (click)="addNewTextSnippet()">
        {{ 'aumico_reports_organization_settings_text_snippets_add_new_button' | i18next }}
    </ham-button>
</div>
<div class="empty-state-wrapper" *ngIf="!(filteredData?.length > 0)">
    <div class="empty-state">
        <span
            class="file-circle-plus-outline-wrapper"
            hamIconShapes
            icon="assets/hamIcons/file-circle-plus-outline.svg"
            [size]="'50px'"
        >
        </span>
        <div class="text1">{{ 'aumico_annual_report_complementary_reports_sample_empty_state_text1' | i18next }}</div>
        <div
            class="text2"
            [innerHTML]="'aumico_annual_report_complementary_reports_sample_empty_state_text2' | i18next"
        ></div>
        <ham-button type="submit" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="addNewTextSnippet()">
            {{ 'aumico_reports_organization_settings_text_snippets_add_new_button' | i18next }}
        </ham-button>
        <div
            class="text3"
            [innerHTML]="'aumico_annual_report_complementary_reports_sample_empty_state_text3' | i18next"
        ></div>
    </div>
</div>
<div #pageWrapper>
    <ham-table-with-actions
        *ngIf="filteredData?.length > 0"
        [dataSource]="filteredData"
        [pageSize]="10"
        [menuItems]="menuItems"
        (rowSelected)="onRowButtonClicked($event)"
        (menuOptionClicked)="onMenuItemClicked($event)"
        (checkBoxSelectionChanged)="onCheckBoxSelectionChanged($event)"
        [pagination]="false"
    >
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_title_column_header' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_description_column_header' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamDateCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_created_at_column_header' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_created_by_column_header' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamDateCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_last_modified_column_header' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_reports_organization_settings_text_snippets_list_modified_by_column_header' | i18next }}
        </ng-template>

        <ng-template hamCell let-element hamTextCol> {{ element?.title || '-' }} </ng-template>
        <ng-template hamCell let-element hamTextCol> {{ element?.description || '-' }} </ng-template>
        <ng-template hamCell let-element hamDateCol>
            {{ element?.createdAt ? (element.createdAt | dateLocale) : '-' }}
        </ng-template>
        <ng-template hamCell let-element hamTextCol>
            {{ element?.createdBy || '-' }}
        </ng-template>
        <ng-template hamCell let-element hamDateCol>
            {{ element?.updatedAt ? (element.updatedAt | dateLocale) : '-' }}
        </ng-template>
        <ng-template hamCell let-element hamTextCol>
            {{ element?.updatedBy || '-' }}
        </ng-template>
    </ham-table-with-actions>
</div>
